import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Residence from "./components/Residence";
import Searchbox from "./components/SearchBox";
import ReactPaginate from "react-paginate";
import axios from "axios";
import noData from "../images/no-data.svg";
import Filter from "./components/utils/Filter";

export default function Hostels(props) {
	const [homestels, setHomestels] = useState([]);
	const [allHomestels, setAlltHomestels] = useState([]);
	const [pageCount, setPageCount] = useState(0);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(24);
	const [loading, setLoading] = useState();
	const [activeFilter, setActiveFilter] = useState(false);
	// bumped when the filter is cleared so the normal list reloads
	const [refresh, setRefresh] = useState(0);
	// location.key changes on every nav click, so re-clicking the link refetches
	const location = useLocation();
	useEffect(() => {
		const controller = new AbortController();
		const fetchHomestels = async () => {
			setLoading(true);
			try {
				const res = await axios({
					method: "get",
					url: `${process.env.REACT_APP_API_URL}/api/v1/residences/homestels?page=${page}&limit=${limit}`,
					signal: controller.signal,
				});
				setPageCount(Math.ceil(res.data.total / limit)); // set pageCount
				const arr = res.data.data.sort(() => Math.random() - 0.5);
				setHomestels(arr);
				setAlltHomestels(res.data.all);
			} catch (error) {
				if (axios.isCancel(error)) return;
				console.log(error);
				setHomestels([]);
			} finally {
				if (!controller.signal.aborted) setLoading(false);
			}
		};

		fetchHomestels();
		return () => controller.abort();
	}, [page, limit, location.key, refresh]);

	const handlePageClick = (p) => {
		setPage(p.selected + 1);
		setLimit(limit);
	};
	return (
		<>
			<div className="container margin-top">
				<div>
					<Filter
						key={location.key}
						type="Homestel"
						setActiveFilter={setActiveFilter}
						setHostels={setHomestels}
						onReset={() => setRefresh((r) => r + 1)}
					/>
				</div>
				<div className="residence-search-area">
					<div>
						<Searchbox type="Homestels" data={allHomestels} />
					</div>
				</div>
				<div className="hostel-flex my-5">
					{loading ? (
						<>
							<div className="text-center " id="loading" />
							<div className="load-separator" />
						</>
					) : homestels?.length === 0 ? (
						<>
							<img
								className="text-center"
								src={noData}
								alt="..."
								style={{ width: 250, height: 250 }}
							/>{" "}
							<br />
						</>
					) : (
						homestels.map((item, index) => {
							return <Residence residence={item} key={item?._id} />;
						})
					)}
				</div>
				{!activeFilter && (
					<ReactPaginate
						breakLabel="..."
						nextLabel=">>"
						onPageChange={handlePageClick}
						// pageRangeDisplayed={5}
						pageCount={pageCount}
						forcePage={page - 1}
						previousLabel="<< "
						renderOnZeroPageCount={null}
						containerClassName="pagination justify-content-center"
						pageClassName="page-item"
						pageLinkClassName="page-link"
						activeClassName=" active"
						activeLinkClassName="active"
						breakClassName="page-item"
						breakLinkClassName="page-link"
						nextClassName="page-item"
						nextLinkClassName="page-link"
						previousClassName="page-item"
						previousLinkClassName="page-link"
					/>
				)}
			</div>
		</>
	);
}
